import { hardenIframe } from '@wix/client-security'

export const overrideIframe = hardenIframe
